module.exports = __webpack_public_path__ + "static/media/lb-small.d9f5e1ef.png";